import { RxDoubleArrowRight } from 'react-icons/rx';

type SectionHeaderProps = {
  title: string;
  size?: number;
  id?: string;
};

const SectionHeader: React.FC<SectionHeaderProps> = ({ title, size = 16, id }) => (
  <div style={{ display: 'flex', flexDirection: 'column' }}>
    <div 
      id={id}
      style={{ display: 'flex', gap: '3px', alignItems: 'center', fontWeight: 'bold', fontSize: `${size}px`, textTransform: 'uppercase' }}
    >
      <div><RxDoubleArrowRight style={{ color: "#fdb419" }} /></div> {title}
    </div>
  </div>
);

export default SectionHeader;